import WorkingUnitSelect, { WorkingUnitSelectProps } from './WorkingUnitSelect';
import { WorkingUnit } from '../../types/WorkingUnit.interface';

export type OfferedClusterSelectProps = {
    selectedCluster: number;
    offeredClusterOptions: WorkingUnit[];
} & Omit<WorkingUnitSelectProps, 'selectedWorkingUnit' | 'workingUnitOptions' | 'valueProp'>;

export const OfferedClusterSelect = ({
    selectedCluster,
    onChange,
    offeredClusterOptions,
    label = 'Offered Cluster',
    ...props
}: OfferedClusterSelectProps) => {
    return (
        <WorkingUnitSelect
            selectedWorkingUnit={selectedCluster}
            workingUnitOptions={offeredClusterOptions}
            onChange={onChange}
            valueProp="id"
            {...props}
        />
    );
};
